var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"frame"},[_c('input-email'),_c('input-password'),_c('input-save-email-pass'),_c('button-login')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }